module.exports = __webpack_public_path__ + "img/继续教育平台.1c3990fa.png";